import { AxiosStatic, AxiosPromise } from 'axios';
import {
  User, TermsOfUse, EditInformation, SupportProperties, CaseInformation, UserTimeState, AttendanceInformation, AttachmentToCaseParams,
} from '../models/api-client';
class UserService {
  public controllerUri: string;

  constructor(public axios: AxiosStatic, public baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
    this.controllerUri = 'Osa/';
  }

  getAddressInfo(debtorNumber: string): AxiosPromise<string> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAddressInfo/${debtorNumber}`);
  }

  getLockedOutPageInfo(): AxiosPromise<string> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetLockedOutPageInfo/`);
  }

  getTermsOfUse(userParams: User): AxiosPromise<TermsOfUse> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}GetTermsOfUse/`, userParams);
  }

  getMaxSizeAttachment(): AxiosPromise<number> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetMaxSizeAttachment/`);
  }

  getEditInformation(debtorNumber: string): AxiosPromise<EditInformation> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetEditInformation/${debtorNumber}`);
  }

  addRequest(supportParams: SupportProperties): AxiosPromise<AttachmentToCaseParams> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}AddRequest/`, supportParams);
  }

  addAttachmentToCase(attachmentToCase: AttachmentToCaseParams): AxiosPromise<boolean> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}AddAttachmentToCase/`, attachmentToCase);
  }

  getInstallationDaysAgo(userParams: User): AxiosPromise<UserTimeState> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}GetInstallationDaysAgo/`, userParams);
  }

  getAllCloseCases(debtorNumber: string): AxiosPromise<CaseInformation[]> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAllCloseCases/${debtorNumber}`);
  }

  getAllOpenCases(debtorNumber: string): AxiosPromise<CaseInformation[]> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAllOpenCases/${debtorNumber}`);
  }

  getAllGCSCases(): AxiosPromise<CaseInformation[][]> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAllGCSCases/`);
  }

  getAttendanceGCSCase(caseId: string): AxiosPromise<AttendanceInformation[]> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAttendanceGCSCase/${caseId}`);
  }

  getAttendanceCase(caseId: string): AxiosPromise<AttendanceInformation[]> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetAttendanceCase/${caseId}`);
  }

  getCustomerProductLine(debtorNumber: number): AxiosPromise<string> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}GetCustomerProductLine/${debtorNumber}`);
  }
}

export default UserService;
